exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "span.lien {\n  cursor: pointer; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/debian/git/lea/lea-front/src/app/shared/paiement/list/list.component.scss
// module id = ../../../../../src/app/shared/paiement/list/list.component.scss
// module chunks = main